<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br><br><br>
                    <div>
                        <p class="texto2">Algo no está funcionando...</p>
                        <p class="texto1">
                            La página no se encuentra disponible.
                            <br>Estamos trabajando para brindarte una solución.
                        </p>
                    </div>
                    <br>
                    <img src="./assets/img/Error404.png" />
                </div>

                <div class="textoAbajo">
                    <p class="textoError">Código de error</p>
                    <img src="./assets/img/Error404.png" />
                    <br>
                    <div>
                        <p class="texto2">Algo no está funcionando...</p>
                        <p class="texto1">La página no se encuentra disponible.
                            <br>Estamos trabajando para brindarte una solución.
                        </p>
                    </div>
                </div>
                <br><br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit"
                        onclick="window.location.href='https://www.sura.co/'">
                        Intentar de nuevo
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>